<template>
  <div id="app">    
    <div class="container">
      <Nav class="nav" />
      <transition name="fade" mode="out-in">
        <router-view class="content" />
      </transition>
      <Bottom />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import Bottom from "@/components/Bottom.vue";
export default {
  name: "Home",
  components: { Nav, Bottom },
  data: () => ({         
  })
};
</script>

<style lang="scss">
  @font-face {
    font-family: "Gotham Ultra";
    src: url("~@/assets/fonts/Gotham-Ultra.woff2") format("woff2"),
      url("~@/assets/fonts/Gotham-Ultra.woff") format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  @font-face {
    font-family: "Gotham";
    src: url("~@/assets/fonts/Gotham-Black.woff2") format("woff2"),
      url("~@/assets/fonts/Gotham-Black.woff") format("woff");
    font-weight: 900;
    font-style: normal;
    font-display: block;
  }

  @font-face {
    font-family: "Gotham Book";
    src: url("~@/assets/fonts/Gotham-Book.woff2") format("woff2"),
      url("~@/assets/fonts/Gotham-Book.woff") format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  @font-face {
    font-family: "Montserrat";
    src: url("~@/assets/fonts/Montserrat-Regular.woff2") format("woff2"),
      url("~@/assets/fonts/Montserrat-Regular.woff") format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  @font-face {
    font-family: "Montserrat";
    src: url("~@/assets/fonts/Montserrat-Bold.woff2") format("woff2"),
      url("~@/assets/fonts/Montserrat-Bold.woff") format("woff");
    font-weight: bold;
    font-style: normal;
    font-display: block;
  }

  @font-face {
    font-family: "Gotham";
    src: url("~@/assets/fonts/Gotham-Medium.woff2") format("woff2"),
      url("~@/assets/fonts/Gotham-Medium.woff") format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: block;
  }
</style>

<style lang="scss">
  h1 {
    color: #fff;
    font-family: "Gotham";
    font-size: 1.5em;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 1em;
    text-transform: uppercase;
    margin:0;
  }
  h2 {
    color:#B2B3B8;
    font-family: "Gotham";
    font-size: 0.9em;
    text-transform: uppercase;
    line-height: 1;
    margin:0;
    letter-spacing: 0;
    margin-bottom:6px;
  }
  .yellow {
    background-image: linear-gradient(269deg, #f5831f 0%, #fed208 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .page {  
    a {
      color:inherit; 
    }
    p {
      color: #ffffff;
      font-family: "Montserrat";
      font-size: 1em;
      letter-spacing: 0;
      line-height: 1.6em;
      margin:1em 0;
      &.footnote {
        color: #B2B3B8;
        font-family: Montserrat;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 19.2px;
        border-top:1px solid rgba(255,255,255,0.35); 
        max-width: 515px;
        padding-top:15px;
        display:inline-block;
      }
      &.large {
      font-size:1.4em;
    }
    }
  }
</style>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;  
  background-color:#0B0B0B;
}
body {
  margin: 0;
  background: #000;  
  &::-webkit-scrollbar {
        width: 0px;
  }    
}
.fade-enter-active {
  transition: all 0.25s ease;
}
.fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.25s ease;
}
.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(-25px);
  opacity: 0;
}
.container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.nav {
  z-index: 1;
  flex-shrink: 0;
}
.content {
  flex-grow: 1;
}
</style>
